<template>
  <div class="hi-lo-group">
    <!-- :win="`o${winCells.twotonine}` === 'o5'`" -->
    <new-bet-lot
      class="hi-lo-group-betlot"
      type="o5"
      :odd="odd('o5')"
      :win="`o${this.winCells.twotonine}` === 'o5'"
      game="group-bet"
      gameType="hi_lo"
      :game-data="gameData"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :disallow-betting="disallowBetting"
      :stake-record-sum="stakeRecordSum('o5')"
      @update-session-storage="onUpdateSessionStorage"
      size="large"
    />
    <new-bet-lot
      class="hi-lo-group-betlot"
      type="o6"
      :odd="odd('o6')"
      :win="`o${this.winCells.jqka}` === 'o6'"
      game="group-bet"
      gameType="hi_lo"
      :game-data="gameData"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :disallow-betting="disallowBetting"
      :stake-record-sum="stakeRecordSum('o6')"
      @update-session-storage="onUpdateSessionStorage"
      size="large"
    />
    <new-bet-lot
      class="hi-lo-group-betlot"
      type="o7"
      :odd="odd('o7')"
      :win="`o${this.winCells.ka}` === 'o7'"
      game="group-bet"
      gameType="hi_lo"
      :game-data="gameData"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :disallow-betting="disallowBetting"
      :stake-record-sum="stakeRecordSum('o7')"
      @update-session-storage="onUpdateSessionStorage"
      size="large"
    />
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["game", "winCellNo", "winCells", "gameData"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot
  },
  data() {
    return {
      games: ["o5", "o6", "o7", "o113"]
    };
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.hi-lo-group {
  width: 100%;
  padding-right: 5px;
}

.hi-lo-group-betlot {
  flex: 1;
  padding: 0 0 0 5px;
}

.hi-lo-group-betlot:first-of-type {
  margin-left: unset;
}

.hi-lo-group-betlot:last-of-type {
  margin-right: unset;
}
</style>
